import { ErrorLike } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { useEffect } from 'react';

import { DialogID, useDialog } from '@components/Dialog';
import { useSnackbarError } from '@hooks/useSnackbarErrors';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { selectMobileMutation } from '@utils/queries/mobile';

import { useSimsStore } from '../store';
import { toSimSettingsInput } from '../utils';

const useMobileSubmit = () => {
  const { basketId } = useBasketContext();
  const { sims, clearSims } = useSimsStore();
  const [submit, { loading }] = useMutation(selectMobileMutation);
  const setSnackbarError = useSnackbarError();

  const updatingDialog = useDialog(DialogID.UPDATING_BUNDLE);

  useEffect(() => {
    updatingDialog.setOpen(loading);
  }, [loading, updatingDialog]);

  const submitMobile = async (onComplete: () => void) => {
    try {
      await submit({
        variables: {
          basketId,
          selection: {
            sims: sims.map(({ id, settings }) => ({
              id,
              settings: toSimSettingsInput(settings),
            })),
          },
        },
      });
      clearSims();
      onComplete();
    } catch (error) {
      setSnackbarError(error as ErrorLike);
    }
  };

  return {
    submitMobile,
    isSubmitting: loading,
  };
};

export { useMobileSubmit };
